import React, { Component } from 'react';
import { connect } from 'react-redux';
import FordCalendar from '../utility/FordCalendar';
import PaxSelector from '../utility/PaxSelector';
import Button from '../utility/Button';
import PriceSummary from './PriceSummary';
import PropTypes from 'prop-types';
import { formatDate } from '../../js/utility';
import { withRouter } from 'react-router';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock';
import { withTranslation } from 'react-i18next';

import {
  setBookingPax,
  setBookingDate,
  setBookingPrice,
  fetchBookingInfo,
  updateBookingInfo
} from '../../actions/booking';

import { calcSimplePrice } from '../../js/utility';

const hideVisibility = {
  display: `none`
}

class BookingMenu extends Component {
  constructor(props) {
    super(props);
    this.lockRef = React.createRef();
    this.handleDateChange = this.handleDateChange.bind(this);
    // this.handlePaxChange = this.handlePaxChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isActive } = this.props;
    if (prevProps.isActive !== isActive) {
      if (isActive) {
        disableBodyScroll(this.lockRef.current);
      } else {
        enableBodyScroll(this.lockRef.current);
      }
    }
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  handleDateChange(date) {
    const {
      updateBookingInfo,
      match,
      // selectedVehicleId,
      selectedVehicleName,
      selectedMeetingPointId
    } = this.props;
    updateBookingInfo(
      match.params.slug,
      date,
      // selectedVehicleId,
      selectedVehicleName,
      selectedMeetingPointId
    );
    window.scrollTo(0, 0);
  }

  handleSelect({ neutral, adult, child }) {
    const pax = neutral || { adult, child };

    if (typeof this.props.onPaxChange === 'function') {
      const total = neutral || adult + child;
      this.props.onPaxChange(total);
    }

    this.props.setBookingPax(pax);
    this.props.setBookingPrice(calcSimplePrice(this.props.bookingInfo, pax));
  }

  // handlePaxChange(pax) {
  //   const { setBookingPax, setBookingPrice, bookingInfo } = this.props;
  //   const price = parseFloat(bookingInfo.booking_summary.price_summary.trip_price);
  //   // const insurance = parseFloat(bookingInfo.booking_summary.price_summary.travel_insurance_price);
  //   setBookingPax(pax);
  //   setBookingPrice(calcSimplePrice(price, 0, pax, bookingInfo.trip_discount, bookingInfo.regardless_pax));
  // }

  render() {
    const {
      isMobile,
      bookingInfo,
      bookingDate,
      bookingPax,
      bookingPrice,
      selectedVehicleName,
      selectedMeetingPointName,
      bookingStep,
      vehicleWasReset,
      meetingPointWasReset,
      dateWasReset,
      isActive,
      isLocked,
      isConfirmed,
      handleClick,
      primaryDriver,
      promoCode,
      handleChange,
      applyCode,
      loading,
      t,
      byorIsMember,
      byorVehicleNo,
      byorSelected,
      vehicleModel,
      match
    } = this.props;

    const { isByAge, isByPax, pax_max, trip_price } = bookingInfo;
    // const pax_min =
    //   bookingInfo.pax_min === 1 && !primaryDriver
    //     ? bookingInfo.pax_min + 1
    //     : bookingInfo.pax_min;
    const pax_min = bookingInfo.pax_min;

    const menuClass = (isMobile
      ? 'fe-menu-mobile'
      : 'fe-menu no-sticky'
    ).concat(isActive ? ' active' : '');

    const perPaxOnly = !trip_price.child_rate ? true : false;

    return (
      <div ref={this.lockRef} className={menuClass}>
        <div className='fe-menu-content'>
          <div className='fe-menu-heading-container'>
            <h4 className='fe-menu-heading'>{t('form:bookingSummary')}</h4>
          </div>
          {/* <div className={`fe-menu-booking-info ${isLocked ? 'hide' : ''}`}> */}
          <div className='fe-menu-booking-info hide'>
            <div className='fe-menu-subheading'>{t('form:getawayTravelDate')}</div>
            <div className={`fe-menu-calendar ${loading ? 'disabled' : ''}`}>
              <FordCalendar
                handleDateChange={this.handleDateChange}
                customAvailDates={bookingInfo.booking_summary.available_dates} // pass in dates received from API fetch
              />
            </div>
            <div className='fe-menu-legend'>
              <div className='fe-menu-legend-item'>
                <span className='fe-menu-legend-color avail' />
                <span className='fe-menu-legend-text'>
                  {t('gen:availDates')}
                </span>
              </div>
              <div className='fe-menu-legend-item'>
                <span className='fe-menu-legend-color unavail' />
                <span className='fe-menu-legend-text'>
                  {t('gen:soldOutNA')}
                </span>
              </div>
              {/* <div className='fe-menu-legend-note'>
                *{t('trip:advBookingNote')}
              </div> */}
            </div>
            {/* <Dropdown
              disabled={loading}
              value={ bookingDate }
              onChange={ this.handleDateChange }
              options={convertToFormattedDates(bookingInfo.booking_summary.available_dates)}
              optionValues={ bookingInfo.booking_summary.available_dates }
            /> */}
            {dateWasReset ? (
              <span className='fe-menu-summary-error'>
                {t('form:dateChanged')}
              </span>
            ) : null}
            <PaxSelector
              isByAge={isByAge}
              isByPax={isByPax}
              value={bookingPax}
              min={pax_min}
              max={pax_max}
              onChange={this.handleSelect}
              showError={true}
              perPaxOnly={perPaxOnly}
              trip_price={bookingPrice}
            />
          </div>
          <div className='fe-menu-summary'>
            <h1 style={hideVisibility}>Booking - {bookingInfo.booking_for}</h1>
            {
            (match.params.slug === 'a-desaru-fruit-farm-resort-staycation' || match.params.slug === "raptor-rev")?
              (<div className='fe-menu-summary-heading'>{t('form:event')}</div>)
              :
              (<div className='fe-menu-summary-heading'>{t('form:getaway')}</div>)
            }
            <span>{bookingInfo.booking_for}</span>
            <div className='fe-menu-summary-heading'>
              {
                (match.params.slug === 'a-desaru-fruit-farm-resort-staycation' || match.params.slug === "raptor-rev")?
                (t('form:getawayDate'))
                :
                (t('form:getawayTravelDate'))
              }
            </div>
            <span>{formatDate(bookingInfo.booking_summary.current_date)}</span>
            {isLocked ? (
              <>
                {/* <div className='fe-menu-summary-heading'>
                  {t('form:getawayTravelDate')}
                </div>
                <span>{formatDate(bookingDate)}</span> */}
                <div className='fe-menu-summary-heading'>
                  {t('form:numPax')}
                </div>
                {isByAge || isByPax ? (
                  <>
                    <span>
                      {bookingPax.adult || bookingPax}&nbsp;
                      {perPaxOnly ? (
                        t('gen:pax')
                      ) : (
                        <>
                          {bookingPax.adult !== 1
                            ? t('gen:paxAdults')
                            : t('gen:paxAdult')}
                          <br />
                          {bookingPax.child || 0}&nbsp;
                          {bookingPax.child !== 1
                            ? t('gen:paxChildren')
                            : t('gen:paxChild')}
                        </>
                      )}
                      {/*  */}
                    </span>
                  </>
                ) : (
                  <span>{bookingPax}</span>
                )}
              </>
            ) : null}
            {!byorIsMember && !byorSelected ? (
              <>
                <div className='fe-menu-summary-heading'>
                  {t('form:vehicleSelection')}
                </div>
                <span>
                  {selectedVehicleName}
                  {vehicleWasReset ? (
                    <>
                      <br />
                      <span className='fe-menu-summary-error'>
                        {t('form:vehicleChanged')}
                      </span>
                    </>
                  ) : null}
                </span>
                <div className='fe-menu-summary-heading'>
                  {t('form:meetingPoint')}
                </div>
                <span>
                  {selectedMeetingPointName}
                  {meetingPointWasReset ? (
                    <>
                      <br />
                      <span className='fe-menu-summary-error'>
                        {t('form:meetingChanged')}
                      </span>
                    </>
                  ) : null}
                </span>
              </>
            ) : byorVehicleNo && (byorIsMember || vehicleModel) ? (
              <>
                {(vehicleModel) ? (
                  <>
                    <div className='fe-menu-summary-heading'>
                      {t('form:vehicleModel')}
                    </div>
                    <span>{vehicleModel}</span>
                  </>
                ) : null}
                <div className='fe-menu-summary-heading'>
                  {t('form:vehicleNo')}
                </div>
                <span>{byorVehicleNo}</span>
              </>
            ) : null}
          </div>
          <PriceSummary
            isLoading={loading && bookingStep !== 1}
            isConfirmed={isConfirmed}
            applyCode={applyCode}
            promoCode={promoCode}
            handleChange={handleChange}
          />
          <div className='fe-menu-confirm booking'>
            <Button onClick={handleClick} disabled={loading}>
              {loading ? `${t('gen:loading')}...` : t('gen:confirm')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

BookingMenu.propTypes = {
  match: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  bookingInfo: PropTypes.object.isRequired,
  bookingDate: PropTypes.string.isRequired,
  bookingPax: PropTypes.oneOfType([PropTypes.number, PropTypes.object])
    .isRequired,
  bookingPrice: PropTypes.object.isRequired,
  selectedVehicleName: PropTypes.string.isRequired,
  // selectedVehicleId: PropTypes.number.isRequired,
  // selectedMeetingPointId: PropTypes.number.isRequired,
  selectedMeetingPointName: PropTypes.string.isRequired,
  vehicleWasReset: PropTypes.bool.isRequired,
  dateWasReset: PropTypes.bool.isRequired,
  setBookingPax: PropTypes.func.isRequired,
  setBookingDate: PropTypes.func.isRequired,
  setBookingPrice: PropTypes.func.isRequired,
  updateBookingInfo: PropTypes.func.isRequired,
  primaryDriver: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  isLocked: PropTypes.bool.isRequired,
  isConfirmed: PropTypes.bool.isRequired,
  handleClick: PropTypes.func,
  promoCode: PropTypes.string,
  applyCode: PropTypes.func,
  bookingStep: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  meetingPointWasReset: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  onPaxChange: PropTypes.func,
  byorIsMember: PropTypes.bool,
  byorVehicleNo: PropTypes.string.isRequired,
  vehicleModel: PropTypes.string.isRequired
};

BookingMenu.defaultProps = {
  isMobile: false,
  isActive: false,
  isLocked: false,
  isConfirmed: false,
  promoCode: '',
  applyCode: null
};

const mapStateToProps = ({ bookingState, tripDetailsState }) => ({
  bookingInfo: bookingState.bookingInfo,
  bookingDate: bookingState.date,
  bookingPax: bookingState.pax,
  bookingPrice: bookingState.bookingPrice,
  bookingStep: bookingState.step,
  selectedVehicleName: bookingState.selectedVehicleName,
  // selectedVehicleId: bookingState.selectedVehicleId,
  // selectedMeetingPointId: bookingState.selectedMeetingPointId,
  selectedMeetingPointName: bookingState.selectedMeetingPointName,
  vehicleWasReset: bookingState.vehicleWasReset,
  meetingPointWasReset: bookingState.meetingPointWasReset,
  dateWasReset: bookingState.dateWasReset,
  primaryDriver: bookingState.primaryDriver,
  loading: bookingState.loading,
  byorIsMember: bookingState.byorIsMember,
  byorVehicleNo: bookingState.byorVehicleNo,
  vehicleModel: bookingState.vehicleModel,
  byorSelected: tripDetailsState.byorSelected
});

const mapDispatchToProps = {
  setBookingPax,
  setBookingDate,
  setBookingPrice,
  fetchBookingInfo,
  updateBookingInfo
};

export default withRouter(
  withTranslation()(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(BookingMenu)
  )
);
